module.exports = __webpack_public_path__ + "static/avatar-119fa8fc0b12e75670cc210331a8f613.jpg";